import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { NEVER, catchError, throwError } from 'rxjs';
import { RoutesPath } from '@core/enums';
import { HTTP_CODE } from '@core/enums';
import { AuthService } from '../services/auth/auth.service';
import { environment } from '@core/envs';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  // If the request URL is in the exclude list, skip the interceptor
  if (excludeURLs.includes(req.url) || !auth.tokens) {
    return next(req);
  }

  // Clone the request and add the authorization header
  if (auth.tokens.cat) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${auth.tokens.cat}`
      }
    });

    // Pass the cloned request with the updated header to the next handler
    return next(authReq).pipe(
      catchError(err => handleAuthError(err, auth.urlInfo.country, auth.urlInfo.source))
    );
  }

  return NEVER;
};

const handleAuthError = (err: HttpErrorResponse, country: string, source: string) => {
  if (err.status === HTTP_CODE.UNAUTHORIZED || err.status === HTTP_CODE.FORBIDEN) {
    const url = `${environment.project.shell}${RoutesPath.LOGOUT_SHELL}/${country}/${source}`;
    sessionStorage.clear();
    window.location.href = url;
    return throwError(() => new Error('Unauthorized'));
  }

  return throwError(() => new Error(err.message));
}

// TODO: melhorar isso? remover para um arquivo externo?
const excludeURLs = [
  'assets/i18n',
  'feature-toggle'
];
